export default "__VITE_ASSET__784c2fa0__"